import axiosConfig from "./axiosConfig";

export interface VoaRejectResponse {
  rejectedAt: string;
  rejectedBy: string;
}

const postVoaReject = async (
  authToken: string,
  sourceRef: string
): Promise<VoaRejectResponse> => {
  const { data } = await axiosConfig.post(
    `/leads/voa/${encodeURIComponent(sourceRef)}/reject`,
    {},
    { headers: { Authorization: `Bearer ${authToken}` } }
  );
  return data;
};

export default postVoaReject;
